import FilterText from 'components/FilterText';
import { ICommercialProduct } from 'interfaces/ICommercialProduct';
import { useMainContext } from 'context/MainContext';
import React, { useCallback, useEffect, useState } from 'react';
import { Button, Col, Row, Table } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { useCommercialProductService } from 'services/commercialProductService';
import {
  enumCommercialProductType,
  enumCommercialProductTypeLabel
} from 'enum/enumCommercialProductType';
import { Edit, VerifiedUser, Delete } from 'styled-icons/material';
import * as S from './style';

const TableCommercialProduct: React.FC = () => {
  const { setDialog } = useMainContext();

  const [CommercialProducts, setCommercialProduct] = useState<
    ICommercialProduct[] | null
  >(null);
  const { commercialProductService } = useCommercialProductService();
  const navigate = useNavigate();

  const getData = useCallback(async () => {
    try {
      const result = await commercialProductService.getAll();
      setCommercialProduct(result);
    } catch (error) {
      console.log(`error in TableUsers - function getData, error:${error}`);
    }
  }, [commercialProductService]);

  const dateFormat = new Intl.DateTimeFormat('pt-BR', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric'
  });

  const handleConfirmDelete = useCallback(
    async (commercialProduct: ICommercialProduct) => {
      try {
        const updatedProduct = {
          ...commercialProduct,
          DeletedDate: new Date()
        };
        await commercialProductService.update(updatedProduct);
        const Products = await commercialProductService.getAll();
        setCommercialProduct(Products);
      } catch (error) {
        console.log(
          `error in AddProduct - function handleConfirm, error:${error}`
        );
      }
    },
    [commercialProductService]
  );

  const handleDelete = (commercialProduct: ICommercialProduct) => {
    setDialog({
      show: true,
      callBackConfirm: () => handleConfirmDelete(commercialProduct),
      textBody: 'Esta ação é irreversível, tem certeza que deseja prosseguir ?'
    });
  };

  useEffect(() => {
    getData();
  }, [getData]);

  return (
    <S.Container>
      <FilterText
        placeholderInput="Nome do Produto Comercial"
        nameFieldToFilter="Name"
        dataToFilter={CommercialProducts}
        setDataToFilter={setCommercialProduct}
      />
      {CommercialProducts && CommercialProducts.length > 0 && (
        <Row>
          <Col>
            <div className="table-thead-fixed">
              <Table className="table-striped text-center" responsive>
                <thead>
                  <tr>
                    <th>Id</th>
                    <th>Nome</th>
                    <th>Tipo</th>
                    <th>Dt. Criação</th>
                    <th aria-label="Ações" />
                  </tr>
                </thead>
                <tbody>
                  {CommercialProducts.map(
                    (commercialProduct: ICommercialProduct) => (
                      <tr key={commercialProduct.CommercialProductId}>
                        <td>{commercialProduct.CommercialProductId}</td>
                        <td>{commercialProduct.Name}</td>
                        <td>
                          {enumCommercialProductTypeLabel.get(
                            commercialProduct.CommercialProductType
                          )}
                        </td>
                        <td>
                          {dateFormat.format(
                            new Date(commercialProduct.CreatedDate)
                          )}
                        </td>
                        <td>
                          <Button
                            type="button"
                            variant="outline-primary"
                            onClick={() =>
                              navigate('addEditCommercialProduct', {
                                state: commercialProduct
                              })
                            }
                            title="Editar"
                          >
                            <Edit size={20} />
                          </Button>
                          <Button
                            style={{ margin: 5 }}
                            onClick={() => handleDelete(commercialProduct)}
                            variant="outline-primary"
                          >
                            <Delete title="Excluir" size={22} />
                          </Button>
                        </td>
                      </tr>
                    )
                  )}
                </tbody>
              </Table>
            </div>
          </Col>
        </Row>
      )}
    </S.Container>
  );
};

export default TableCommercialProduct;
